import { render } from "./ListViewPage.vue?vue&type=template&id=4b016116&ts=true"
import script from "./ListViewPage.vue?vue&type=script&lang=ts"
export * from "./ListViewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__